<template lang="pug">
.d-flex
  .flex-grow-1
    filter-date-range.mr-2(ref="date" :dates.sync="dateFilter" initialize-date)
    filter-medications.mr-2(:filter.sync="medicationFilter")
    filter-providers(:filter.sync="providerFilter")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterDateRange from '@/components/clinic/reports/filters/FilterDateRange.vue'
import FilterProviders from '@/components/clinic/reports/filters/FilterProviders.vue'
import FilterMedications from '@/components/clinic/reports/filters/FilterMedications.vue'

export default {
  components: { FilterProviders, FilterMedications, FilterDateRange },
  props: ['filters'],
  data: () => ({
    key: 0,
    medicationFilter: {},
    providerFilter: {},
    dateFilter: [],
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.providerFilter.key) {
        filters.push(this.providerFilter)
      }
      if (this.medicationFilter.key) {
        filters.push(this.medicationFilter)
      }
      if (this.dateFilter.length > 0) {
        filters.push({ key: 'begin', value: this.dateFilter[0]})
        filters.push({ key: 'until', value: this.dateFilter[1]})
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.providerFilter = {}
      this.medicationFilter = {}
      this.dateFilter = []
      this.$refs.date.clear()
    },
  }
}
</script>